// Sanctum bearer-token session, kept in localStorage so engineers stay signed in
// between visits. The API decides whether the token is still valid; a 401 from
// any request clears it (see the axios interceptor in main.js).

const TOKEN_KEY = 'token'
const USER_KEY = 'user'

function read (key) {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

export function getToken () {
  return read(TOKEN_KEY)
}

export function getUser () {
  try {
    return JSON.parse(read(USER_KEY)) || null
  } catch (e) {
    return null
  }
}

export function isLoggedIn () {
  return !!getToken()
}

export function setSession (token, user) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user || null))
}

export function clearSession () {
  try {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    localStorage.removeItem('auth')
  } catch (e) {
    // Storage unavailable; nothing to clear.
  }
}
